"use client"

import { useEffect, useState } from "react"
import { observer } from "mobx-react-lite"
import { Plus } from "lucide-react"

import { useAppContext } from "../../../shared/functions/Context"
import showModalFromId from "../../../shared/functions/ModalShow"

import Modal from "../../../shared/components/Modal"

import MODAL_NAMES from "../../dialogs/ModalName"
import EditTemplateModal from "../questionnaire/modals/EditTemplateModal"
import CreateNewTemplateModal from "../questionnaire/modals/CreateTemplateModal"
import CriteriaBox from "../questionnaire/components/CriteriaBox"


const CreateTemplate = observer(() => {
  const { api, store } = useAppContext()
  const [loading, setLoading] = useState(true)

  const addNewTemplate = () => {
    showModalFromId(MODAL_NAMES.THREE_SIXTY_FEEDBACK.CREATE_TEMPLATE_MODAL)
  }

  const templates = store.templates.all.map((template) => template.asJson)

  useEffect(() => {
    const load = async () => {
      try {
        await api.template.getAll()
      } catch (error) {
        console.error("Failed to fetch templates:", error)
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [api.template])

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64 w-full">
        <div className="relative">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-200"></div>
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-600 border-t-transparent absolute top-0 left-0"></div>
        </div>
      </div>
    )
  }

  return (
    <div className="w-full space-y-6">
      {/* Header Section */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 p-6 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl border border-blue-100">
        <div>
          <h2 className="text-2xl font-bold text-slate-800 mb-2">Feedback Templates</h2>
          <p className="text-slate-600">Create and manage custom feedback templates</p>
        </div>
        <button
          onClick={addNewTemplate}
          className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-semibold px-6 py-3 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
        >
          <Plus className="h-5 w-5" />
          Create Template
        </button>
      </div>

      {/* Content Section */}
      {templates.length > 0 ? (
        <CriteriaBox value={templates} />
      ) : (
        <div className="text-center py-16 bg-white rounded-2xl border border-slate-200 shadow-sm">
          <div className="max-w-md mx-auto">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Plus className="h-8 w-8 text-blue-600" />
            </div>
            <h3 className="text-xl font-semibold text-slate-800 mb-2">No Templates Available</h3>
            <p className="text-slate-600 mb-6">
              Create your first feedback template to get started with the evaluation process.
            </p>
            <button
              onClick={addNewTemplate}
              className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-semibold px-6 py-3 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <Plus className="h-5 w-5" />
              Create Your First Template
            </button>
          </div>
        </div>
      )}

      {/* Modals */}
      <Modal modalId={MODAL_NAMES.THREE_SIXTY_FEEDBACK.CREATE_TEMPLATE_MODAL}>
        <CreateNewTemplateModal />
      </Modal>
      <Modal modalId={MODAL_NAMES.THREE_SIXTY_FEEDBACK.EDIT_TEMPLATE_MODAL}>
        <EditTemplateModal />
      </Modal>
    </div>
  )
})

export default CreateTemplate
